import React from 'react';
import { getGroupsList } from '../../../../models/groups';
import i18n from '../../../../i18n';
import { formatDate } from '../../../../utils/common';
import StatusBadge from '../../../common/StatusBadge';
import { AUCTION_STATUS, DELIVERY_STATUS } from '../../../../constants/status';
import HeaderBanner from '../../../common/HeaderBanner';
import { SideBar } from '../../sidebar';
import FilterSection from '../../../common/Filter';
import Select from 'react-select';
import { selectStyles } from '../../../../styles/components/js/selectStyle';
import { TableSkeleton } from '../../../common/skelton/TableSkelton';
import DataTable from 'react-data-table-component';
import { tableStyles } from '../../../../styles/components/js/tableStyle';
import NoData from '../../../common/NoData';
import { getOrganizationList } from '../../../../models/organization';
import { getAuctions } from '../Auction/services/auctionService';
import { BiddersList } from '../Auction/components/BiddersList';
import { ArrowLeft } from 'lucide-react';
import { withRouter } from '../../../../hoc/withRouter';
import { getLoggedUser } from '../../../../state/user';

const user = getLoggedUser();

class AuctionList extends React.Component {
  constructor() {
    super();
    this.state = {
      search: {
        status: '',
        deliveryStatus: '',
        client: null,
        group: null,
      },
      clients: [],
      groups: [],
      auctions: [],
      isloading: false,
      limit: 15,
      page: 1,
      total: 0,
      groupLoading: false,
      showBidders: false,
      bidders: [],
      startDate: null,
      endDate: null,
    };

    this.handleSearchChange = this.handleSearchChange.bind(this);
  }
  componentDidMount() {
    window.scrollTo(0, 0);
    // Parse URL query params
    const params = new URLSearchParams(window.location.search);
    const search = {
      client: params.get('client') || null,
      group: params.get('group') || null,
      status: params.get('status') || '',
      deliveryStatus: params.get('deliveryStatus') || '',
    };
    const page = parseInt(params.get('page')) || 1;
    const limit = parseInt(params.get('limit')) || 15;
    const startDate = params.get('startDate') || null;
    const endDate = params.get('endDate') || null;

    this.setState({ search, page, limit, startDate, endDate }, () => {
      this.getAllOrganization();
      this.getAllAuctions();
    });
  }

  // Update URL without refreshing page
  updateUrlQuery(q) {
    const queryString = new URLSearchParams(
      Object.fromEntries(Object.entries(q).filter(([_, v]) => v !== '' && v !== null))
    ).toString();
    window.history.replaceState(null, '', `${window.location.pathname}?${queryString}`);
  }
  async getAllAuctions() {
    this.setState({ isloading: true });
    let { limit, page, startDate, endDate } = this.state;
    let { client, group, status, deliveryStatus } = this.state.search;
    const q = {
      page: page,
      limit: limit,
    };

    if (client) q.client = client;
    if (group) q.group = group;
    if (status) q.status = status;
    if (deliveryStatus) q.deliveryStatus = deliveryStatus;
    if (startDate) q.startDate = startDate;
    if (endDate) q.endDate = endDate;

    // Update URL
    this.updateUrlQuery(q);

    try {
      const response = await getAuctions(q);
      if (response.success) {
        this.setState({
          auctions: response.data,
          total: response.meta.total,
        });
      }
    } catch (error) {
      console.error('Auction fetch failed:', error);
    } finally {
      this.setState({ isloading: false });
    }
  }

  async getAllOrganization() {
    const response = await getOrganizationList();
    let data = response.data;
    const clients = data.map((item) => {
      return {
        value: item.id,
        label: item.organization_name,
      };
    });
    this.setState({ clients });
  }

  async getAllGroups() {
    this.setState({ grouploading: true });
    let { client } = this.state.search;
    let q = client ? `organization=${client}` : '';
    const response = await getGroupsList(q);
    if (response.success) {
      let data = response.data;
      const groups = data.map((item) => {
        return {
          value: item.id,
          label: item.group_name,
        };
      });
      this.setState({ groups, groupLoading: false });
    } else {
      this.setState({ groups: [], grouploading: false });
    }
  }

  getColumns = () => {
    const isCLient = user.role === 'C';
    return [
      {
        name: 'MZAD ID',
        width: '110px',
        sortable: true,
        wrap: true,
        cell: (row) => <span className="highlight-table-value">MZAD {row.id}</span>,
      },
      {
        name: i18n.t('bid_count'),
        width: '110px',
        sortable: true,
        wrap: true,
        cell: (row) => (
          <button
            className="btn-new btn-new--action "
            disabled={row.bidders_count > 0 ? false : true}
            onClick={() => {
              this.setState({ showBidders: true, bidders: row.bidders });
            }}
          >
            {row.bidders_count}
          </button>
        ),
      },
      ...(!isCLient
        ? [
            {
              name: i18n.t('project_code'),
              minWidth: '140px',
              cell: (row) => (
                <span className="highlight-table-value">{row.group_relation?.project_code}</span>
              ),
            },
          ]
        : []),
      {
        name: i18n.t('auction_name'),
        minWidth: '140px',
        cell: (row) => <span className="highlight-table-value-secondary">{row.title}</span>,
      },
      {
        name: i18n.t('group_name'),
        width: '130px',
        cell: (row) => (
          <span className="highlight-table-value-secondary">{row.group_relation?.group_name}</span>
        ),
        wrap: true,
      },
      ...(!isCLient
        ? [
            {
              name: i18n.t('client_name'),
              width: '130px',
              cell: (row) => (
                <span className="highlight-table-value-secondary">
                  {row.organization_relation.organization_name}
                </span>
              ),
              wrap: true,
            },
          ]
        : []),

      {
        id: 7,
        name: i18n.t('start_date'),
        width: '120px',
        cell: (row) => <span>{formatDate(row.start_date)}</span>,
        wrap: true,
      },
      {
        name: i18n.t('end_date'),
        width: '120px',
        cell: (row) => <span>{formatDate(row.end_date)}</span>,
        wrap: true,
      },

      ...(!isCLient
        ? [
            {
              name: i18n.t('payment_due_date'),
              width: '160px',
              cell: (row) => {
                if (!row.approved_date) return '-';

                const approvedDate = new Date(row.approved_date);
                const today = new Date();
                const diffTime = approvedDate.getTime() - today.getTime();
                const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

                const isOverdue = diffDays < 0;
                const displayText = isOverdue
                  ? `${Math.abs(diffDays)} days overdue`
                  : `${diffDays} days left`;

                return (
                  <span className={`highlight-table-value ${isOverdue ? 'overdue' : 'upcoming'}`}>
                    {displayText}
                  </span>
                );
              },
              wrap: true,
              center: true,
            },
          ]
        : []),

      ...(!isCLient
        ? [
            {
              name: i18n.t('project_duration'),
              width: '150px',
              cell: (row) => {
                if (!row.actual_start_date || !row.expected_end_date) return '-';

                const start = new Date(row.group_relation?.actual_start_date);
                const end = new Date(row.group_relation?.expected_end_date);
                const today = new Date();

                // Normalize to midnight (to avoid partial-day errors)
                start.setHours(0, 0, 0, 0);
                end.setHours(0, 0, 0, 0);
                today.setHours(0, 0, 0, 0);

                // Total project duration
                const duration = Math.round((end - start) / (1000 * 60 * 60 * 24));

                // Days left (can be negative)
                const daysLeft = Math.round((end - today) / (1000 * 60 * 60 * 24));

                let statusText = '';
                let statusClass = '';

                if (daysLeft > 0) {
                  statusText = `${daysLeft} days left`;
                  statusClass = 'upcoming';
                } else if (daysLeft === 0) {
                  statusText = 'Due today';
                  statusClass = 'due-today';
                } else {
                  statusText = `Overdue by ${Math.abs(daysLeft)} days`;
                  statusClass = 'overdue';
                }

                return (
                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <span className="highlight-table-value">{`${duration} days total`}</span>
                    <span className={`highlight-table-value ${statusClass}`}>{statusText}</span>
                  </div>
                );
              },
              wrap: true,
              center: true,
            },
          ]
        : []),

      ...(!isCLient
        ? [
            {
              name: i18n.t('final_bid'),
              width: '100px',
              cell: (row) => (
                <span className="highlight-table-value-secondary">
                  {row.latest_bid?.bid_amount ?? '--'}
                </span>
              ),
              wrap: true,
              center: true,
            },
          ]
        : []),

      {
        name: i18n.t('status'),
        cell: (row) => <StatusBadge status={AUCTION_STATUS[row.status]} />,
        wrap: true,
      },

      ...(!isCLient
        ? [
            {
              name: i18n.t('delivery_status'),
              width: '140px',
              cell: (row) => <StatusBadge status={DELIVERY_STATUS[row.delivery_status]} />,
              wrap: true,
            },
          ]
        : []),
    ];
  };

  handleSearchChange = (e) => {
    const { name, value } = e.target;
    this.setState(
      (prevState) => {
        const updatedSearch = {
          ...prevState.search,
          [name]: value,
          // Clear group when client changes or is cleared
          ...(name === 'client' && { group: null }),
        };
        return { search: updatedSearch };
      },
      () => {
        if (name === 'client' && value) {
          // Only load if client has value
          this.getAllGroups();
        }
      }
    );
  };

  handleSearch = () => {
    this.getAllAuctions();
  };

  handleClear = () => {
    const defaultSearch = {
      status: '',
      client: null,
      group: null,
    };

    this.setState({ search: defaultSearch, page: 1, selectedRows: [] }, () => {
      this.getAllAuctions();
    });
  };

  onChangePage = (page) => {
    this.setState({ page: page }, () => {
      this.getAllAuctions();
    });
  };

  onChangeRowsPerPage = (limit) => {
    this.setState({ limit: limit, page: 1 }, () => {
      this.getAllAuctions();
    });
  };

  render() {
    const { groups, auctions, clients, showBidders, bidders } = this.state;

    return (
      <React.Fragment>
        <HeaderBanner title={i18n.t('auctions')} />
        <section className="dashboard-section">
          <div className="container">
            <div className="row">
              <div className="col-xl-3 col-lg-12 col-md-12">
                {!this.state.hideSidebar && <SideBar />}
              </div>
              <div
                className={
                  this.state.hideSidebar
                    ? 'col-xl-12 col-lg-12 col-md-12'
                    : 'col-xl-9 col-lg-12 col-md-12'
                }
              >
                <div className="card">
                  <div className="card-header">
                    <div className="expand-dashboard">
                      <span
                        style={{ fontSize: '1rem', marginRight: '0.5rem', cursor: 'pointer' }}
                        onClick={() => {
                          this.setState({
                            hideSidebar: !this.state.hideSidebar,
                          });
                        }}
                      >
                        {this.state.hideSidebar && <i className="icon-size-actual"></i>}
                        {!this.state.hideSidebar && <i className="icon-size-fullscreen"></i>}
                      </span>
                    </div>
                    <button
                      className="button1 button1-gradient button1-back"
                      onClick={() =>
                        this.props.navigate(user.role === 'C' ? '/client-dashboard' : '/management')
                      }
                    >
                      <ArrowLeft size={18} className="icon" />
                      <span>Back</span>
                    </button>
                  </div>
                  <div className="card-body">
                    {user.role !== 'C' && (
                      <FilterSection
                        loading={this.state.isloading}
                        onSearch={this.handleSearch}
                        onClear={this.handleClear}
                      >
                        {/* Client Dropdown */}
                        <div className="react-select-wrapper">
                          <Select
                            options={clients}
                            value={
                              clients.find((c) => c.value === this.state.search.client) || null
                            }
                            onChange={(selectedOption) => {
                              const clientValue = selectedOption ? selectedOption.value : null;
                              this.setState(
                                (prevState) => ({
                                  search: {
                                    ...prevState.search,
                                    client: clientValue,
                                    group: null,
                                  },
                                  groups: [],
                                }),
                                () => {
                                  if (clientValue) {
                                    this.getAllGroups();
                                  }
                                }
                              );
                            }}
                            name="client"
                            styles={selectStyles}
                            menuPlacement="auto"
                            menuPortalTarget={document.body}
                            placeholder={i18n.t('select_client')}
                            className=""
                          />
                          {/* Only show label when there's a selected value */}

                          <label className="react-select-label">{i18n.t('client_name')}</label>
                        </div>

                        {/* Group Dropdown */}
                        <div className="react-select-wrapper">
                          <Select
                            options={groups}
                            value={groups.find((c) => c.value === this.state.search.group) || null}
                            onChange={(selectedOption) => {
                              this.setState((prevState) => ({
                                search: {
                                  ...prevState.search,
                                  group: selectedOption ? selectedOption.value : null,
                                },
                              }));
                            }}
                            name="group"
                            styles={selectStyles}
                            menuPlacement="auto"
                            menuPortalTarget={document.body}
                            placeholder={i18n.t('search_group')}
                            isLoading={this.state.groupLoading}
                            isDisabled={this.state.groupLoading}
                            //   noOptionsMessage={() => i18n.t('no_groups_found')}
                            className=""
                          />
                          {/* Only show label when there's a selected value */}

                          <label className="react-select-label">{i18n.t('group')}</label>
                        </div>
                      </FilterSection>
                    )}

                    <div className="Data-Listing">
                      {this.state.isloading ? (
                        <TableSkeleton columns={10} rows={10} />
                      ) : this.state.auctions.length ? (
                        <DataTable
                          responsive={true}
                          columns={this.getColumns()}
                          data={auctions}
                          customStyles={tableStyles}
                          highlightOnHover
                          pagination
                          paginationServer
                          paginationTotalRows={this.state.total}
                          paginationPerPage={this.state.limit}
                          paginationDefaultPage={this.state.page}
                          paginationRowsPerPageOptions={[15, 25, 50, 100]}
                          paginationComponentOptions={{
                            rowsPerPageText: i18n.t('rows_per_page'),
                            rangeSeparatorText: i18n.t('out'),
                          }}
                          onChangePage={this.onChangePage}
                          onChangeRowsPerPage={this.onChangeRowsPerPage}
                        />
                      ) : (
                        <NoData
                          message={i18n.t('no_auctions_available')}
                          actionText={i18n.t('refresh')}
                          onAction={this.getAllAuctions.bind(this)}
                        />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <BiddersList
          show={showBidders}
          bidders={bidders}
          onClose={() => this.setState({ showBidders: false })}
        />
      </React.Fragment>
    );
  }
}

export default withRouter(AuctionList);
